var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M7 10L12 15 17 10z","transform":"rotate(180 12 12)"}})}
var staticRenderFns = []

export { render, staticRenderFns }